<template>
  <single-test-result
    v-if="loaded"
    :test="test"
    :response-id="responseId"
    :response="response"
    :is-public="false"
  />
</template>
<script>
  import SingleTestResult from './SingleTestResult';

  export default {
    components: {
      SingleTestResult
    },

    props: {
      responseId: {
        type: String,
        required: true
      },

      response: {
        type: Object,
        default: () => {}
      },

      test: {
        type: Object,
        required: true
      },

      loaded: {
        required: true
      }
    }
  };
</script>
